module.exports = __webpack_public_path__ + "img/ywyk-instructions09.985189ea.jpg";